const FALLBACK_VALUE = 'None';

export function getGaIDFromCookie(cookie) {
  return cookie?.split('.').slice(-2).join('.') || FALLBACK_VALUE;
}

export function getDidomiConsentFromCookie(didomiCookie) {
  try {
    let decoded = JSON.parse(atob(didomiCookie));
    if (decoded.vendors.enabled?.length) {
      return `Accepted: ${
        decoded.vendors.disabled?.length ? decoded.vendors.enabled.join() : 'all'
      }`;
    }
    return 'Denied: all';
  } catch {
    return FALLBACK_VALUE;
  }
}

export function getHash() {
  return new Date().getTime() + '.' + (Math.random() + 1).toString(36).slice(5);
}
